import { render, staticRenderFns } from "./BudgetTableItem.vue?vue&type=template&id=66594cdb&"
import script from "./BudgetTableItem.vue?vue&type=script&lang=ts&"
export * from "./BudgetTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetTableItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports